import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';

const BlogPost = () => {
    const { postId } = useParams();
    const navigate = useNavigate();
    const [headings, setHeadings] = useState([]);

    const blogPosts = {
        "cleaner-tomorrow-odisha": {
            title: "A Cleaner Tomorrow: Corenova's Renewable Energy Vision in Odisha",
            date: "January 15, 2024",
            readTime: "8 min read",
            author: "Corenova Team",
            authorImage: "/images/corenova-team.jpg",
            authorRole: "Renewable Energy Experts",
            image: "/images/renewable (1).png",
            category: "renewable-energy",
            content: `
        <p>With energy needs rising and climate challenges becoming more pressing, renewable energy isn't just an option—it's our future. At Corenova Renewable Energy, we're not just observing the clean energy momentum; we are providing impactful, contractible renewable energy services in Odisha to meet the demands of today and the challenges of tomorrow.</p>

        <h2 id="about"><strong>About Corenova Renewable Energy</strong></h2>
        <p>Corenova is a premier renewable energy company based in Odisha, providing full-stack solar, hydro, wind, and energy consulting services. Known for our innovation, compliance, and sustainability, we are helping shape the future of clean energy in India—one project at a time. Whether you are a homeowner, business owner, or public sector partner, Corenova's services are designed to create lasting impact.</p>

        <h2 id="mission"> <strong>A Clean Energy Mission With Local Impact</strong></h2>
        <p>Our mission is simple: to curb carbon emissions, create local jobs, and make clean energy accessible and affordable for everyone. Odisha, with its abundant natural resources and growing energy needs, presents a unique opportunity for renewable energy development and is perfectly positioned to become a clean energy leader.</p>
        <p>From solar power in the plains to hydroelectric projects in the hilly regions, the state is ripe for a clean energy transformation. Corenova is leading this mission, delivering solutions that are not only safe and sustainable for our clients but also beneficial for local communities and the planet.</p>

<h2 id="services"><strong>Our Core Renewable Energy Services</strong></h2>
<p>
  At Corenova, we offer complete 
  <a href="/services" title="Renewable Energy Services in Odisha">
    <strong>Renewable Energy Services in Odisha</strong>
  </a>
  that support real-world outcomes while providing long-term value.
</p>



        <h3 id="solar"><strong>Solar Energy Solutions</strong></h3>
        <p>Whether you are looking to <a href="/services/solar"> <strong>install rooftop panels in Bhubaneswar</strong></a>or a large-scale solar farm, our team will design, install, and manage a custom system to reduce your carbon footprint and cut electricity bills.</p>

        <h3 id="hydro"><strong>Hydroelectric Power Projects</strong></h3>
        <p>Corenova specializes in small and micro hydro projects that produce sustainable power for businesses while preserving natural habitats and water resources.</p>

        <h3 id="wind"><strong>Wind Energy Systems</strong></h3>
        <p>From coastlines to inland wind corridors, our wind energy solutions can be deployed as standalone projects or complement solar and hydro systems for optimal energy performance.</p>

        <h3 id="consulting"><strong>Project Consulting & Compliance</strong></h3>
        <p>We know that navigating energy regulations can be complex. Corenova ensures your project is compliant and future-proof by guiding you through every decision, process, and regulatory hurdle.</p>

        <h2 id="vision"><strong>Corenova's Vision: Impact-Driven, Innovation-Focused</strong></h2>
        <p>Our vision includes a diverse mix of solar, wind, and hydro power to reduce dependency on fossil fuels and create jobs in the green economy. What makes us unique is not just what we do, but how we do it:</p>
      `,
            visionPoints: [
                {
                    title: "Intelligent Design",
                    description: "We provide site-specific solutions based on your location, goals, and budget—no cookie-cutter approaches."
                },
                {
                    title: "Digital Tracking",
                    description: "Our systems feature remote monitoring for real-time performance assessment and proactive problem-solving."
                },
                {
                    title: "Community Engagement",
                    description: "We work to ensure local communities understand and benefit from the clean energy transition, strengthening their future."
                },
                {
                    title: "Sustainability at Every Level",
                    description: "From planning to installation, we minimize our environmental footprint and promote sustainable energy usage."
                }
            ],

            contentContinued: `
        <h2 id="future">Building a Greener Future Together</h2>
        <p>At Corenova, we believe clean energy is more than a business—it is a commitment. Every solar panel, hydro turbine, and wind system we install is a step toward a brighter, cleaner Odisha and a more sustainable India.</p>
        
        <p>Join us in this mission. Whether you're considering renewable energy for your home, business, or community, Corenova is here to guide you every step of the way toward a cleaner, more sustainable future.</p>
      `,
        },
        
        "odisha-solar-panel-installation": {
            title: "Odisha Solar Panel Installation: Why This Is the Ideal Time to Invest in Solar",
            date: "April 5, 2024",
            readTime: "10 min read",
            author: "Solar Energy Team",
            authorImage: "/images/solar-team.jpg",
            authorRole: "Solar Energy Specialists",
            image: "/images/solar installation.png",
            category: "solar",
            content: `
        <p>Solar energy is spearheading the clean energy revolution in Odisha.
         Due to the year-round sunshine, rising electricity prices, and increased awareness of sustainability, installing <a href="/services/solar"> <strong>solar panels in Odisha</strong></a> is becoming more than just a fad; it's a wise investment for your house or place of business.</p>
        
        <p>Our specialty at <a href="/home"><strong>Corenova Renewable</strong></a> is offering cost-effective, high-performance solar solutions throughout Odisha. We are here to make the transition easy and stress-free, whether you're in a rural block seeking energy independence or in Bhubaneswar, Cuttack, or Sambalpur.</p>

        <h2 id="why-odisha"><strong>Why Is Odisha the Ideal State for Solar Energy?</strong></h2>
        <p>The topography and climate of Odisha provide a number of inherent benefits:</p>
        <ul>
          <li>More than 300 sunny days a year</li>
          <li>High solar irradiance, which is ideal for producing electricity</li>
          <li>Unstable power supplies in many areas; solar provides energy security</li>
          <li>Growing grid electricity costs—solar ultimately saves you money</li>
        </ul>
        <p>There has never been a better time to install solar panels in Odisha, as the state and federal governments are promoting the use of renewable energy through subsidies, net metering regulations, and awareness campaigns.</p>

        <h2 id="advantages"><strong>Advantages of Using Corenova to Install Solar Panels in Odisha</strong></h2>
        <p>There are long-term advantages to switching to solar power, but choosing the right partner is essential. This is what makes Corenova unique:</p>
        
        <ul>
          <li><strong>Complete Solutions:</strong> We take care of everything, from system design and site survey to installation, approval, and upkeep.</li>
          <li><strong>Scalable and reasonably priced:</strong> We provide solutions for all kinds of applications, including rooftops in homes, businesses, schools, hospitals, and even agricultural settings.</li>
          <li><strong>Assistance from Government Subsidies:</strong> Our professionals assist you in applying for federal and state subsidies through programs such as Odisha's rooftop solar program and PM-Surya Ghar.</li>
          <li><strong>Quick Installation and Assistance:</strong> With our skilled local team in Odisha, we guarantee a speedy system uptime and round-the-clock post-installation assistance.</极速li>
        </ul>

        <h2 id="system-types"><strong>Solar Panel System Types That We Install</strong></h2>
        <p>You have the following options when thinking about <a href="services/solar"> <strong>installing solar panels </strong> </a> in Odisha:</p>

        <h3 id="on-grid"><strong>1. The Solar System On-Grid</strong></h3>
        <p>Has a direct grid connection. Excellent for residences and commercial buildings in places like Cuttack and Bhubaneswar.</p>

        <h3 id="off-grid"><strong>2. Solar System Off-Grid</strong></h3>
        <p>Ideal for isolated or rural locations with erratic grid power. Incorporates battery storage.</p>

        <h3 id="hybrid"><strong>3. The Solar System's Hybrid</strong></h3>
        <p>Maximizes flexibility and provides backup during power outages by combining grid and battery power.</p>

        <h3 id="ground-mount"><strong>4. Solar Plants Mounted on the Ground</strong></h3>
        <p>Perfect for agricultural projects, institutions, or sizable plots.</p>

        <h2 id="case-studies"><strong>Impact in the Real World: Case Studies of Odisha</strong></h2>
        <ul>
          <li>A family in Bhubaneswar cut their electricity bill by more than ₹2,000 per month with a 5kW rooftop system.</li>
          <li>A small dairy farm in Balasore used an off-grid solar setup to cut their diesel generator usage by 80%.</li>
          <li>Rayagada's rural school no longer has to worry about power outages to operate fans, lights, and computers.</li>
        </ul>
      `,
            contentContinued: `
        <h2 id="process"><strong>Are You All Set to Go Solar?</strong></h2>
        <p>Below are the Procedure to follow before installation:</p>
        <ol>
          <li>Schedule a Free Consultation</li>
          <li>System Design and Site Survey</li>
          <li>Options for Quotes and Financing</li>
          <li>Certified Technician Installation</li>
          <li>Net metering and grid connection</li>
          <li>System Upkeep & Monitoring</li>
        </ol>

        <h2 id="why-corenova"><strong>Why Opt for Corenova Renewable?</strong></h2>
        <ul>
          <li>Reliable solar panel installation specialists in Odisha</li>
          <li>Over 100 completed projects</li>
          <li>System monitoring and responsive assistance</li>
          <li>Local presence with nearby skilled installers</li>
        </ul>

        <h2 id="conclusion"><strong>Conclusion</strong></h2>
        <p>Now is the ideal time to invest in solar power as Odisha transitions to a more energy-secure and sustainable future. Solar energy isn't just a wise decision it's the future due to the abundance of sunlight, rising energy demands, and encouraging government regulations. From small businesses and households to large institutions, we at Corenova Renewable make solar panel installation in Odisha easy, dependable, and reasonably priced.</p>

        <p>Are you prepared to switch? For a free consultation and quote, get in touch with us right now.</p>
        
        <p>🌐 Go to: <a href="https://www.corenovarenewable.com/" target="_blank" rel="noopener">https://www.corenovarenewable.com/</a></p>
        <p>📧 Send an email to: <a href="mailto:corenovarenewable@gmail.com">corenovarenewable@gmail.com</a></p>
      `
        },

        "odisha-wind-energy-solutions": {
  title: "Odisha Wind Energy Solutions: Using Corenova to Drive Advancement Renewably",
  date: "June 12, 2024",
  readTime: "12 min read",
  author: "Wind Energy Team",
  authorImage: "/images/wind-team.jpg",
  authorRole: "Wind Energy Specialists",
  image: "/images/SOLAR 1 (1).png",
  category: "wind",
  content: `
    <p>A state renowned for its industrial might and abundance of natural resources, Odisha is now aiming for a new frontier: clean,<a href="/home"> <strong>renewable energy</strong>/a> . Wind power is one of the most promising and underutilized resources in the area.
     We at Corenova Renewable Energy think that the secret to a more resilient and environmentally friendly energy future lies in Odisha's <a href="/services/wind"><strong>wind energy solutions</strong></a>.</p>

    <h2 id="potential"><strong>Odisha's Wind Potential: A New Prospect</strong></h2>
    <p>Wind energy is subtly becoming a potent ally in Odisha's clean energy transition, even though solar power has recently taken center stage. The state is ideally situated to develop onshore and hybrid wind projects due to its more than 200 km of coastline, high elevation, and favorable wind conditions.</p>
    
    <h3 id="why-wind"><strong>Why wind energy is particularly appealing to Odisha?</strong></h3>
    <ul>
      <li>Particularly in districts like Ganjam, Balasore, and Kendrapara, there are strong coastal wind patterns.</li>
      <li>When solar generation is at its lowest, such as at night and during the monsoon, wind can produce electricity.</li>
      <li>That Encourage Wind Development: The Odisha Renewable Energy Policy actively promotes wind development by providing land access and incentives.</li>
      <li>Villages and isolated areas that experience frequent blackouts are best served by small wind turbines.</li>
    </ul>

    <h2 id="vision"><strong>Odisha's Wind Energy Vision by Corenova</strong></h2>
    <p>At Corenova Renewable, we are energy partners rather than merely service providers. Our objective is to provide scalable, cutting-edge wind energy solutions to all regions of Odisha, promoting sustainable development in homes, businesses, public institutions, and agriculture.</p>
    <p>Corenova offers turnkey solutions, from design and approvals to installation and maintenance, whether you need a standalone wind turbine, a wind-solar hybrid system, or a large-scale grid-connected project.</p>

    <h2 id="services"><strong>What We Provide</strong></h2>
    
    <h3 id="evaluations"><strong>Wind Site Evaluations & Feasibility Studies</strong></h3>
    <p>We evaluate your site's suitability for wind energy production using satellite modeling and real-time wind data.</p>

    <h3 id="design"><strong>Custom System Design</strong></h3>
    <p>We customize your wind system according to grid access, wind speeds, terrain, and energy requirements.</p>

    <h3 id="installation"><strong>Installation & Commissioning</strong></h3>
    <p>Our engineers guarantee quality, safety, and performance from foundations to turbine erection and electrical integration.</p>

    <h3 id="integration"><strong>Integration of Grid or Off-Grid</strong></h3>
    <p>Our systems can function independently with solar integration or battery backup, or they can connect straight to the grid.</p>

    <h3 id="maintenance"><strong>Observation and upkeep</strong></h3>
    <p>To guarantee system longevity, we provide on-site support, preventive maintenance, and long-term performance tracking.</p>

    <h2 id="applications"><strong>Wind Energy Applications in Odisha</strong></h2>
    <ul>
      <li><strong>Industrial Parks:</strong> reducing expenses and carbon emissions while powering operations in the coastal industrial belts of Odisha.</li>
      <li><strong>Distant Communities:</strong> Tribal and off-grid communities' benefit from light and connectivity provided by standalone turbines.</li>
      <li><strong>Agri-Energy Initiatives:</strong> supplying energy to cold storage facilities, grain mills, and water pumps in rural farming areas.</li>
      <li><strong>Public Establishments:</strong> Buildings owned by local governments, hospitals, and schools can become energy independent.</li>
    </ul>
  `,
  contentContinued: `
    <h2 id="advantages"><strong>Wind Energy's Advantages for Odisha</strong></h2>
    <ul>
      <li><strong>Stable Power Supply:</strong> Wind energy makes the grid more stable, particularly in rural and coastal regions.</li>
      <li><strong>Eco-friendly:</strong> less dependent on fossil fuels and zero emissions.</li>
      <li><strong>Cost-Effective Over Time:</strong> Wind energy significantly lowers operating costs following the initial investment.</li>
      <li><strong>Local Employment:</strong> In rural and coastal areas, wind projects create both skilled and unskilled jobs.</li>
      <li><strong>Energy Security:</strong> Lessens susceptibility to power outages and changes in fuel prices.</li>
    </ul>

    <h2 id="why-corenova"><strong>Why Corenova Renewable?</strong></h2>
    <ul>
      <li><strong>Odisha-Focused Expertise:</strong> We are aware of the state's distinct topography, laws, and energy requirements.</li>
      <li><strong>Trusted Engineering:</strong> Project managers, wind experts, and engineers with expertise in renewable energy make up our team.</li>
      <li><strong>Full Project Lifecycle Support:</strong> We are here to help you at every stage, from 24/7 support to wind resource analysis.</li>
      <li><strong>Sustainability-Driven Approach:</strong> We concentrate on developing systems that are not only effective but also sustainable from an economic and environmental standpoint.</li>
    </ul>

    <h2 id="call-to-action"><strong>Are You Prepared for the Future?</strong></h2>
    <p>Wind resources are found naturally in Odisha. It requires audacious action. Wind energy solutions in Odisha are now within your grasp with Corenova Renewable as your partner; they're a calculated investment in your aspirations for sustainability and energy independence.</p>

    <h2 id="conclusion"><strong>Conclusion</strong></h2>
    <p>Odisha is at a turning point in its clean energy development, and wind power presents a fantastic chance to promote sustainable growth, particularly in rural and coastal areas. Wind energy has the potential to be a dependable component of Odisha's renewable energy mix with the correct infrastructure, planning, and experience.</p>
    <p>We at Corenova Renewable are dedicated to transforming this potential into advancement. Together, let's create a wind-powered Odisha.</p>
    <p>Corenova Renewable is here to help you harness the power of the wind, whether you're a homeowner, community organizer, or business leader wishing to embrace renewable energy.</p>
    
    <div class="contact-info">
      <p>🌐 Come See Us: <a href="https://www.corenovarenewable.com/" target="_blank">www.corenovarenewable.com</a></p>
      <p>📧 Email: <a href="mailto:corenovarenewable@gmail.com">corenovarenewable@gmail.com</a></p>
    </div>
  `
}
    };

    const post = blogPosts[postId];

    // Extract headings from content
//   useEffect(() => {
//   if (!post) return;

//   const fullContent = `${post.content || ''}${post.contentContinued || ''}`;
//   const parser = new DOMParser();
//   const doc = parser.parseFromString(fullContent, 'text/html');

//   const headingElements = doc.querySelectorAll('h2, h3');
//   const extractedHeadings = Array.from(headingElements)
//     .filter((heading) => heading.id) 
//     .map((heading) => ({
//       id: heading.id,
//       text: heading.textContent.replace(/\*/g, '').trim(), 

//       level: heading.tagName, 
//     }));

//   setHeadings(extractedHeadings);
// }, [post]);


    if (!post) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                    <h1 className="text-2xl font-bold text-red-600 mb-4">404 - Post Not Found</h1>
                    <button
                        onClick={() => navigate('/blog')}
                        className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                    >
                        Back to Blog
                    </button>
                </div>
            </div>
        );
    }

    // Related posts based on category
    const relatedPosts = Object.entries(blogPosts)
        .filter(([id, p]) => id !== postId && p.category === post.category)
        .slice(0, 2);

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Hero Section with Background Image */}
            <section
                className="relative bg-gradient-to-br from-green-700/80 to-blue-800/80 text-white py-16 md:py-24"
                style={{
                    backgroundImage: `url(${post.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}
            >
                <div className="absolute inset-0 bg-black opacity-50"></div>
                <div className="container relative z-10 max-w-4xl mx-auto px-4">
                    <button
                        onClick={() => navigate('/blog')}
                        className="inline-flex items-center text-sm font-medium text-white hover:text-green-200 mb-6 transition-colors"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                        </svg>
                        Back to Blog
                    </button>

                    <div className="flex flex-col md:flex-row items-start gap-8">
                        <div className="flex-1">
                            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 leading-tight">
                                {post.title}
                            </h1>
                            <div className="flex flex-wrap items-center gap-4 text-sm md:text-base">
                                <div className="flex items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                    </svg>
                                    {post.author}
                                </div>
                                <div className="flex items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                    </svg>
                                    {post.date}
                                </div>
                                <div className="flex items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    {post.readTime}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Content with Sidebar */}
            <section className="py-12 bg-gray-50">
                <div className="container max-w-6xl mx-auto px-4">
                    <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
                        {/* Main Content Area */}
                        <div className="lg:col-span-3">
                            <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8">
                                {/* Article Content */}
                                <article className="prose prose-lg max-w-none">
                                    <div dangerouslySetInnerHTML={{ __html: post.content }} />

                                    {/* Vision Points Grid */}
                                    {post.visionPoints && (
                                        <div className="my-8">
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                {post.visionPoints.map((point, index) => (
                                                    <div key={index} className="bg-green-50 p-6 rounded-xl border border-green-100">
                                                        <div className="flex items-start mb-3">
                                                            <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center text-white font-bold mr-3 flex-shrink-0">
                                                                {index + 1}
                                                            </div>
                                                            <h3 className="text-lg font-semibold text-green-800">{point.title}</h3>
                                                        </div>
                                                        <p className="text-green-700 ml-11">{point.description}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* Continued Content */}
                                    {post.contentContinued && (
                                        <div dangerouslySetInnerHTML={{ __html: post.contentContinued }} />
                                    )}

                                    {/* Tags/Categories */}
                                    <div className="mt-12 pt-8 border-t border-gray-100">
                                        <h3 className="text-lg font-semibold text-gray-800 mb-4">Categories</h3>
                                        <div className="flex flex-wrap gap-2">
                                            <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm font-medium">
                                                {post.category === 'renewable-energy' ? 'Renewable Energy' : 'Solar Energy'}
                                            </span>
                                            <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
                                                Sustainability
                                            </span>
                                            <span className="px-3 py-1 bg-orange-100 text-orange-800 rounded-full text-sm font-medium">
                                                Odisha
                                            </span>
                                        </div>
                                    </div>

                                    {/* Author Bio */}
                                    <div className="mt-8 pt-8 border-t border-gray-100">
                                        <div className="flex items-start gap-4">
                                            <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                                                {post.author.charAt(0)}
                                            </div>
                                            <div>
                                                <h4 className="font-semibold text-gray-800">{post.author}</h4>
                                                <p className="text-sm text-gray-600 mb-2">{post.authorRole}</p>
                                                <p className="text-sm text-gray-700">
                                                    Corenova Renewable Energy is leading the transition to clean energy in Odisha with innovative solar, wind, and hydro solutions.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </article>
                            </div>

                            {/* Related Posts */}
                            {relatedPosts.length > 0 && (
                                <div className="mt-12">
                                    <h2 className="text-2xl font-bold text-gray-800 mb-6">Related Articles</h2>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        {relatedPosts.map(([id, relatedPost]) => (
                                            <Link
                                                key={id}
                                                to={`/blog/${id}`}
                                                className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow"
                                            >
                                                <div className="h-48 overflow-hidden">
                                                    <img
                                                        src={relatedPost.image}
                                                        alt={relatedPost.title}
                                                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                                                    />
                                                </div>
                                                <div className="p-6">
                                                    <h3 className="font-semibold text-lg mb-2 line-clamp-2">{relatedPost.title}</h3>
                                                    <p className="text-gray-600 text-sm mb-4">{relatedPost.date} • {relatedPost.readTime}</p>
                                                    <span className="inline-block px-3 py-1 bg-green-100 text-green-800 rounded-full text-xs font-medium">
                                                        {relatedPost.category === 'renewable-energy' ? 'Renewable Energy' : 'Solar'}
                                                    </span>
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Sidebar */}
                        <div className="lg:col-span-1">
                            <div className="sticky top-24">
                                {/* Table of Contents */}
                                {headings.length > 0 && (
                                    <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
                                        <h3 className="font-semibold text-lg text-gray-800 mb-4">Table of Contents</h3>
                                        <nav className="space-y-2">
                                            {headings.map((heading) => (
                                                <a 
                                                    key={heading.id}
                                                    href={`#${heading.id}`}
                                                    className={`block text-green-600 hover:text-green-700 text-sm py-1 ${heading.level === 'H3' ? 'pl-4' : ''}`}
                                                >
                                                    {heading.text}
                                                </a>
                                            ))}
                                        </nav>
                                    </div>
                                )}

                                {/* CTA Box */}
                                <div className="bg-green-600 rounded-xl shadow-lg p-6 text-white">
                                    <h3 className="font-semibold text-lg mb-3">Ready to Go Solar?</h3>
                                    <p className="text-sm mb-4">Get a free consultation and quote for your renewable energy project.</p>
                                    <a href="/contact" className="w-full bg-white text-green-600 font-semibold py-2 px-4 rounded-lg hover:bg-gray-100 transition-colors">
                                        Contact Us
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default BlogPost;